// extracted by mini-css-extract-plugin
module.exports = {"dealerPadding":"Rok_T"};